import { useMigrateGridWidgetsToSidebar } from 'modules/desktop/pages/MainPage/hooks/useMigrateGridWidgetsToSidebar'
import { useSidebarWidgetsStore } from 'modules/desktop/pages/MainPage/stores'
import { useGetAllDesktopSettingsQuery } from 'shared/api/containerApi'
import { useTopDockStore } from 'shared/stores/topDockStore'
import { useWallpaperStore } from 'shared/stores/wallpaperStore'

export const useGetAllDesktopSettings = () => {
  const setPredefinedWallpapers = useWallpaperStore(
    state => state.setPredefinedWallpapers
  )
  const setCurrentWallpaper = useWallpaperStore(
    state => state.setCurrentWallpaper
  )
  const setCustomWallpapers = useWallpaperStore(
    state => state.setCustomWallpapers
  )
  const setPinnedAppIds = useTopDockStore(state => state.setPinnedAppIds)
  const setPlacement = useSidebarWidgetsStore(state => state.setPlacement)

  // One-time cleanup for users who still have widgets left over on the
  // desktop grid from before widgets moved back to the sidebar.
  useMigrateGridWidgetsToSidebar()

  useGetAllDesktopSettingsQuery({
    onSuccess: data => {
      if (!data) return

      const {
        predefined_wallpapers,
        active_wallpaper,
        wallpapers,
        pinned_apps,
        widget_bar_location
      } = data ?? {}

      setPredefinedWallpapers(predefined_wallpapers ?? [])
      setCustomWallpapers(
        (wallpapers ?? []).map(wallpaper => ({
          id: wallpaper.id,
          image: wallpaper.url
        }))
      )

      const state = useWallpaperStore.getState()
      const selected = (
        active_wallpaper?.type === 'custom'
          ? state.customWallpapers
          : state.predefinedWallpapers
      ).find(item => item.id === active_wallpaper?.id)
      if (selected) setCurrentWallpaper(selected)
      else if (active_wallpaper?.id && active_wallpaper?.url)
        setCurrentWallpaper({
          id: active_wallpaper.id,
          image: active_wallpaper.url
        })
      else
        setCurrentWallpaper(
          state.predefinedWallpapers[0] ?? { id: '', image: '' }
        )
      setPinnedAppIds(pinned_apps ?? [])
      if (widget_bar_location) {
        setPlacement(widget_bar_location)
      }
    }
  })
}
